import { useState } from 'react';
import { Container, Row, Col, Nav, Navbar, Offcanvas, Modal, Button } from 'react-bootstrap';
import {
  FaTachometerAlt, FaChalkboardTeacher, FaPlayCircle,
  FaWallet, FaCalendarCheck, FaUserCircle, FaSignOutAlt,
} from 'react-icons/fa';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Layout.css';

const LINKS = [
  { to: '/student/dashboard', label: 'Dashboard',       icon: <FaTachometerAlt /> },
  { to: '/student/teachers',  label: 'Browse Teachers', icon: <FaChalkboardTeacher /> },
  { to: '/student/bookings',  label: 'My Bookings',     icon: <FaPlayCircle /> },
  { to: '/student/classes',   label: 'My Classes',      icon: <FaCalendarCheck /> },
  { to: '/student/wallet',    label: 'Wallet',          icon: <FaWallet /> },
  { to: '/student/profile',   label: 'My Profile',      icon: <FaUserCircle /> },
];

export default function StudentLayout() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const close = () => setShowSidebar(false);
  const open = () => setShowSidebar(true);

  const doLogout = async () => {
    setShowLogout(false);
    await logout();
    navigate('/student/login');
  };

  const renderLinks = () => (
    <Nav className="flex-column">
      {LINKS.map((l) => (
        <Nav.Link as={NavLink} to={l.to} key={l.to} onClick={close}>
          <span className="me-2">{l.icon}</span>{l.label}
        </Nav.Link>
      ))}
      <Nav.Link onClick={() => setShowLogout(true)}>
        <FaSignOutAlt className="me-2" />Logout
      </Nav.Link>
    </Nav>
  );

  return (
    <>
      <Navbar variant="dark" expand="lg" className="app-navbar px-3">
        <Navbar.Brand>Dial Tutor</Navbar.Brand>
        <Navbar.Toggle onClick={open} />
        <Navbar.Collapse>
          <div className="ms-auto welcome-text">Welcome {user?.profile?.name || user?.email}</div>
        </Navbar.Collapse>
      </Navbar>

      <Offcanvas show={showSidebar} onHide={close}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Dial Tutor</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{renderLinks()}</Offcanvas.Body>
      </Offcanvas>

      <Container fluid>
        <Row>
          <Col md={2} className="d-none d-md-block sidebar p-3">{renderLinks()}</Col>
          <Col md={10} className="p-4 content"><Outlet /></Col>
        </Row>
      </Container>

      <Modal show={showLogout} onHide={() => setShowLogout(false)} centered>
        <Modal.Header closeButton><Modal.Title>Confirm Logout</Modal.Title></Modal.Header>
        <Modal.Body>Are you sure you want to exit?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLogout(false)}>Cancel</Button>
          <Button variant="danger" onClick={doLogout}>Logout</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
